import { ContextWrapper } from '@common/contexts/ContextWrapper';
import { UserStore } from '@hospital/views/_shared/userprofile/UserStore';

export const UserStoreContextWrapper = new ContextWrapper<UserStore>();
